module.exports = __webpack_public_path__ + "img/slider6.9b38f989.jpg";